import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import { capitalize, capitalizeFirstWord, pluralize } from 'swag-common/utils/strings';
export const EmbellishmentChangeLocationConfirmationPopup = ({
  open,
  params: {
    newMethodId,
    newProdTimeIndex,
    newMethodName,
    unavailableLocations = [],
    oldMethodName
  },
  onCancel,
  onConfirm
}) => {
  const getTextPartials = () => {
    const count = unavailableLocations.length;
    return {
      locationsNames: unavailableLocations.join(', '),
      locationsText: pluralize(count, 'location', 's', true),
      beForm: count > 1 ? 'are' : 'is',
      thisForm: count > 1 ? 'those' : 'this'
    };
  };
  const getTitle = () => {
    const {
      locationsNames,
      locationsText,
      beForm
    } = getTextPartials();
    return `${capitalizeFirstWord(locationsNames)} ${locationsText} ${beForm} unavailable for ${newMethodName}!`;
  };
  const getMsg = () => {
    const {
      locationsNames,
      locationsText,
      beForm,
      thisForm
    } = getTextPartials();
    return `The ${locationsNames} ${locationsText} ${beForm} unavailable for this decoration method. If you still want ${thisForm} ${locationsText}, please swap back to ${oldMethodName}.`;
  };
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    title: getTitle(),
    msg: getMsg(),
    confirmText: `Change to ${capitalize(newMethodName)}`,
    cancelText: `Keep ${capitalize(oldMethodName)}`,
    onCancel: onCancel,
    onConfirm: () => onConfirm(newMethodId, newProdTimeIndex)
  });
};